import React from "react";
import PersonIcon from "@mui/icons-material/Person";
import AddIcon from "@mui/icons-material/Add";
import PeopleIcon from "@mui/icons-material/People";
import {
  Fab,
  TableCell,
  Table,
  TableHead,
  TableRow,
  TableBody,
  Divider,
  TextField,
  Button,
} from "@mui/material";
import AddItemModal from "./AddItemModal";
import AddTeamModal from "./AddTeamModal";
import BookingMember from "../../../models/BookingMembers";
import EditIcon from "@mui/icons-material/Edit";
import ClearIcon from "@mui/icons-material/Clear";
import BookingTeams from "../../../models/BookingTeams";
import BookingMembers from "../../../models/BookingMembers";
import { EventOptionAvailabilityTypesEnum } from "../../../models/EventOptionAvailabilityTypes";

const IndividualColumns: string[] = [
  "Teilnehmer",
  "Altersklasse",
  "Preis",
  "Aktionen",
];
const TeamColumns: string[] = [
  "Teilnehmer",
  "Altersklasse",
  "Preis",
  "Aktionen",
];

class Member extends React.Component<any, any> {
  componentDidMount() {
    this.props.fetchGenderTypes();
    this.props.fetchOptions();
    this.props.fetchPrices();

    if (
      this.props.booking !== undefined &&
      this.props.booking.id !== undefined
    ) {
      this.props.fetchBookingMembersList();
      this.props.fetchTeams();
    }
  }

  mapTeamMemberRow = (member: BookingMembers): JSX.Element => {
    return (
      <TableRow key={member.id}>
        <TableCell>{`${member.firstName} ${member.lastName}`}</TableCell>
        <TableCell>{member.memberAgeGroupName}</TableCell>
        <TableCell>{`€ ${
          typeof member.overallPrice != "undefined" && member.overallPrice
            ? member.overallPrice.toFixed(2).replace(".", ",")
            : "0,-"
        }`}</TableCell>
        <TableCell>
          <EditIcon
            className="icon"
            onClick={() => {
              this.props.changeMode("Edit");
              this.props.showAddTeamBookingMemberModal(member);
            }}
          />
          <ClearIcon
            className="icon"
            onClick={() => this.props.delete(member.id)}
          />
        </TableCell>
      </TableRow>
    );
  };

  public render() {
    let enableTeamleaderCheckbox = true;
    if (
      this.props.bookingMember.teamId !== null &&
      this.props.bookingMember.teamId !== undefined
    ) {
      enableTeamleaderCheckbox =
        (this.props.bookingMembersList as BookingMember[])
          .filter((x) => x.teamId === this.props.bookingMember.teamId)
          .filter(
            (x) => x.teamLeader === true && x.id !== this.props.bookingMember.id
          ).length === 0;
    }

    const individualTableColumns: JSX.Element[] = IndividualColumns.map((x) => {
      return <TableCell>{x}</TableCell>;
    });

    const teamTableColumns: JSX.Element[] = TeamColumns.map((x) => {
      return <TableCell>{x}</TableCell>;
    });

    const bookingMembersList = (
      this.props.bookingMembersList as BookingMember[]
    ).map((x) => {
      if (x.teamId == null) {
        return (
          <TableRow key={x.id}>
            <TableCell>{`${x.firstName} ${x.lastName}`}</TableCell>
            <TableCell>{x.memberAgeGroupName}</TableCell>
            <TableCell>{`€ ${
              typeof x.overallPrice != "undefined" && x.overallPrice
                ? x.overallPrice.toFixed(2).replace(".", ",")
                : "0,-"
            }`}</TableCell>
            <TableCell>
              <EditIcon
                className="icon"
                onClick={() => {
                  this.props.changeMode("Edit");
                  this.props.showAddBookingMemberModal(x);
                }}
              />
              <ClearIcon
                className="icon"
                onClick={() => this.props.delete(x.id)}
              />
            </TableCell>
          </TableRow>
        );
      }
    });

    const teamsTables = (this.props.bookingTeams as BookingTeams[]).map((x) => {
      const teamMembers = (this.props.bookingMembersList as BookingMember[])
        .filter((y) => y.teamId === x.id)
        .map((y) => {
          return this.mapTeamMemberRow(y);
        });
      return (
        <div className="row mt-3" key={x.id}>
          <div className="col">
            <b>{x.teamName}</b>
            <EditIcon
              className="icon"
              onClick={() => {
                this.props.showAddTeamModal();
                this.props.changeTeamMode("Edit");
                this.props.changeCurrentTeam(x);
              }}
            />
            <ClearIcon
              className="icon"
              onClick={() => this.props.deleteTeam(x.id)}
            />
          </div>

          {x.active == false &&
            teamMembers.length < this.props.eventObject.minTeamSize && (
              <b style={{ color: "red" }}>
                &nbsp;
                {`Es müssen mindestens ${this.props.eventObject.minTeamSize} Personen pro Team angemeldet werden.`}
              </b>
            )}
          {x.active == false &&
            (this.props.bookingMembersList as BookingMember[])
              .filter((y) => y.teamId === x.id)
              .filter((y) => y.teamLeader === true).length === 0 &&
            this.props.eventObject.teamLeaderRequired === true && (
              <b style={{ color: "red", display: "inline" }}>
                &nbsp;{`Es muss genau ein Teamleiter ausgewählt werden`}
              </b>
            )}
          <Table className="objects-table table">
            <TableHead>
              <TableRow>{teamTableColumns}</TableRow>
            </TableHead>
            <TableBody>{teamMembers}</TableBody>
          </Table>
        </div>
      );
    });

    return (
      <div className="card">
        <div className="card-header">Teilnehmer</div>
        <div className="card-body">
          {(this.props.eventObject.availabilityId ===
            EventOptionAvailabilityTypesEnum.Einzel ||
            this.props.eventObject.availabilityId ===
              EventOptionAvailabilityTypesEnum.Beide) && (
            <>
              <div className="row">
                <PersonIcon />
                <h4>Einzelanmeldungen</h4>
                {this.props.IsSingleAvailable && (
                  <Fab
                    size="small"
                    className="ml-2"
                    onClick={() => {
                      this.props.changeMode("Submit");
                      this.props.showAddBookingMemberModal(new BookingMember());
                    }}
                  >
                    <AddIcon />
                  </Fab>
                )}
              </div>
              <div className="row mt-3">
                <Table className="objects-table table">
                  <TableHead>
                    <TableRow>{individualTableColumns}</TableRow>
                  </TableHead>
                  <TableBody>{bookingMembersList}</TableBody>
                </Table>
              </div>
            </>
          )}
          {(this.props.eventObject.availabilityId ===
            EventOptionAvailabilityTypesEnum.Team ||
            this.props.eventObject.availabilityId ===
              EventOptionAvailabilityTypesEnum.Beide) && (
            <>
              {/*Here starts the Team section*/}
              <div
                className={
                  this.props.eventObject.availabilityId ===
                  EventOptionAvailabilityTypesEnum.Beide
                    ? "row mt-5"
                    : "row"
                }
              >
                <PeopleIcon />
                <h4>Teamanmeldungen</h4>
                {this.props.IsTeamPlayerAvailable &&
                  this.props.bookingTeams.length > 0 && (
                    <Fab
                      size="small"
                      className="ml-2"
                      onClick={() => {
                        this.props.changeMode("Submit");
                        this.props.showAddTeamBookingMemberModal(
                          new BookingMember()
                        );
                      }}
                    >
                      <AddIcon />
                    </Fab>
                  )}
              </div>
              {this.props.IsTeamAvailable && (
                <Button
                  size="small"
                  variant="contained"
                  color="primary"
                  className="btnBlue"
                  onClick={() => this.props.showAddTeamModal()}
                >
                  Team hinzufügen
                </Button>
              )}
              {teamsTables}
            </>
          )}
          <Divider className="mt-3" />
          <div className="row mt-3">
            <div className="col-sm-2 position-relative mt-3">
              <b className="position-absolute bottom-0">Gesamt Preis:</b>
            </div>
            <div className="col-sm-2 position-relative mt-3">
              <span className="position-absolute bottom-0">{`€ ${
                typeof this.props.booking.bookingTotal != "undefined" &&
                this.props.booking.bookingTotal
                  ? this.props.booking.bookingTotal.toFixed(2).replace(".", ",")
                  : "0,-"
              }`}</span>
            </div>
            {this.props.isAdmin && (
              <div className="col-sm-2 mt-3">
                <TextField
                  label="Alternativer Betrag"
                  name="bookingAlternativePrice"
                  onChange={(e: any) => {
                    e.target.value = e.target.value.replace(",", ".");
                    this.props.changeBooking(e);
                  }}
                  value={
                    this.props.booking.bookingAlternativePrice !== undefined &&
                    this.props.booking.bookingAlternativePrice !== null
                      ? this.props.booking.bookingAlternativePrice
                          .toString()
                          .replace(".", ",")
                      : ""
                  }
                  fullWidth
                />
              </div>
            )}
          </div>
          <div className="row">
            <div className="col-sm-4">
              {/* <TextField label='Begründung' multiline fullWidth /> */}
            </div>
          </div>
        </div>
        {(this.props.bookingMemberModal ||
          this.props.teamBookingMemberModal) && (
          <AddItemModal
            hide={this.props.hideModal}
            team={this.props.teamBookingMemberModal}
            genderTypes={this.props.genderTypes}
            options={this.props.options}
            prices={this.props.prices}
            fetchPrices={this.props.fetchPrices}
            fetchOptions={this.props.fetchOptions}
            changeMember={this.props.changeMember}
            bookingMember={this.props.bookingMember}
            addOption={this.props.addOption}
            submit={this.props.submit}
            selectedOptions={this.props.selectedOptions}
            bookingTeams={this.props.bookingTeams}
            validFields={this.props.validFields}
            showGender={this.props.eventObject.memberGenderTypeRequired}
            disableSaveButton={this.props.disableSaveButton}
            switchSaveButton={this.props.switchSaveButton}
            enableTeamleaderCheckbox={enableTeamleaderCheckbox}
            resetSelectedOptions={this.props.resetSelectedOptions}
          />
        )}
        {this.props.teamModal && (
          <AddTeamModal
            hide={this.props.hideModal}
            changeNewTeam={this.props.changeNewTeam}
            newTeam={this.props.newTeam}
            submitNewTeam={this.props.submitNewTeam}
          />
        )}
      </div>
    );
  }
}

export default Member;
